<template>
  <div class="img-input mb-5">
    <b-field :label="label" label-position="horizontal">
      <input type="file" :name="name" :id="id" :class="inputClass" :accept="accept" @change="onFileChange" />
    </b-field>
    <small v-if="infoText">{{ infoText }}</small>
    <figure v-if="previewUrl" class="image mt-2">
      <img :src="previewUrl" />
    </figure>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Imagen',
    },
    infoText: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: 'image/png,image/jpg,image/jpeg',
    },
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    inputClass: {
      type: String,
      default: 'file form-control',
    },
    imageType: {
      type: String,
      required: true, // Tipo de imagen (por ejemplo, 'portada', 'cover')
    },
    initialUrl: {
      type: String,
      default: null, // URL inicial de la imagen (si existe)
    },
  },
  data() {
    return {
      previewUrl: this.initialUrl, // URL temporal para vista previa (inicia con la URL proporcionada)
      fileData: null, // Objeto con datos del archivo
    };
  },
  watch: {
    initialUrl(newVal) {
      // Actualiza la vista previa si la URL inicial cambia
      this.previewUrl = newVal;
    },
  },
  methods: {
    onFileChange(event) {
      const input = event.target;
      if (input && input.files && input.files.length > 0) {
        const file = input.files[0];

        // URL solo para vista previa
        this.previewUrl = URL.createObjectURL(file);

        this.fileData = {
          file,              // <-- Enviamos el File real
          name: file.name,
          type: file.type,
          imageType: this.imageType,
        };

        this.$emit('file-selected', this.fileData);
      } else {
        console.warn('No se pudo obtener el archivo del evento.');
      }
    },
  },
  beforeDestroy() {
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  },
};
</script>

<style scoped>
.img-input {
  max-width: 600px;
}
img {
  max-height: 200px;
  width: auto !important;
}
</style>
